import DashboardLayout from '../layouts/DashboardLayout';

export const agencyList = {
  path: '/agency',
  component: DashboardLayout,
  name: 'Agency',
  children: [
    {
      path: '',
      name: 'AgencyList',
      component: () => import (/* webpackChunkName: "about" */'../pages/agency/AgencyList.vue'),
      meta: {
        roles: ['agency-admin_read', 'agency-user_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý đại lý'
        }]
      },
    },
    {
      path: 'create',
      name: 'CreateAgency',
      component: () => import (/* webpackChunkName: "about" */'../pages/agency/components/AgencyForm.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý đại lý',
          to: '/agency',
        }, {
          title: 'Tạo mới đại lý',
          to: '',
        }],
        roles: ['agency-admin_create', 'agency-user_create'],
      },
    },
    {
      path: 'edit/:id',
      name: 'EditAgency',
      component: () => import (/* webpackChunkName: "about" */'../pages/agency/components/AgencyForm.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý đại lý',
          to: '/agency',
        }, {
          title: 'Chỉnh sửa đại lý',
          to: '',
        }],
        roles: ['agency-admin_update'],
      },
    },
    {
      path: 'detail/:id',
      name: 'DetailAgency',
      component: () => import (/* webpackChunkName: "about" */'../pages/agency/AgencyDetail.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý đại lý',
          to: '/agency',
        }, {
          title: 'Chi tiết đại lý',
        }],
        roles: ['agency-admin_read', 'agency-user_read'],
      },
    },

    {
      path: 'detail/:id/order-create',
      name: 'AgencyOrderCreate',
      component: () => import(/* webpackChunkName: "about" */'../pages/agency/components/OrderCreate.vue'),
      meta: {
        roles: ['agency-admin_update', 'agency-admin_create', 'agency-user_read'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: 'detail/:id/order-edit',
      name: 'AgencyOrderEdit',
      component: () => import(/* webpackChunkName: "about" */'../pages/agency/components/OrderCreate.vue'),
      meta: {
        roles: ['agency-admin_read', 'agency-admin_update', 'agency-admin_create', 'agency-user_read'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: 'order-list-all',
      name: 'OrderListAll',
      component: () => import (/* webpackChunkName: "about" */'../pages/agency/OrderListAll.vue'),
      meta: {
        roles: ['agency-admin_read', 'agency-user_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách tất cả đơn hàng'
        }]
      },
    },
    {
      path: 'active-code-detail/:id',
      name: 'ActiveCodeDetail',
      component: () => import (/* webpackChunkName: "about" */'../pages/agency/components/activeCodeTab/components/ActiveCodeDetail'),
      meta: {
        roles: ['agency-admin_read', 'agency-user_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Quản lý đại lý',
          to: '/agency',
        }, {
          title: 'Chi tiết mã kích hoạt'
        }]
      },
    },
    {
      path: 'employee-report',
      name: 'AgencyEmployeeReport',
      component: () => import (/* webpackChunkName: "about" */'../pages/agency/components/report/EmployeeReport.vue'),
      meta: {
        roles: ['agency-admin_read', 'agency-user_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo nhân viên'
        }]
      },
    },
  ],
}